<template>
  <div  class="p-grid">

    <TabView>
      <!-- ================ -->
      <!-- SEASON MANAGEMENT-->
      <!-- ================ -->
      <TabPanel header="Saison">

        <h5>Maintenance Mode</h5>
        <InputSwitch v-model="checkMaintenance"/>

        <Accordion>
          <AccordionTab header="Saison erstellen">
            <InitSeason></InitSeason>
          </AccordionTab>
          <AccordionTab header="Aktualisiere Spieltag">
            <InitMatchDay></InitMatchDay>
          </AccordionTab>
        </Accordion>
      </TabPanel>

      <!-- =============== -->
      <!-- USER MANAGEMENT -->
      <!-- =============== -->
      <TabPanel header="Benutzer">
        <!--
                <TabView>

                  <TabPanel>
                    <Panel header="Benutzer">
                      <template #icons>
                        <button class="p-panel-header-icon p-link mr-2" @click="toggle">
                          <span class="pi pi-cog"></span>
                        </button>
                        <Menu id="config_menu" ref="menu" :model="items" :popup="true"/>
                      </template>
                    </Panel>
                  </TabPanel>
        </TabView>
        -->

        <Accordion>

          <!-- ToDo: 21.07.24 (TN) Add button to create a new user -->
          <AccordionTab header="Benutzerliste">
            <UserList></UserList>
          </AccordionTab>

          <AccordionTab header="Rollenliste">
            <RoleList></RoleList>
          </AccordionTab>
        </Accordion>
      </TabPanel>

      <TabPanel header="Importieren">
        <FileUploader></FileUploader>
      </TabPanel>

    </TabView>
  </div>
</template>

<script>
import UserService from '../services/user.service';
import InitMatchDay from "../components/InitMatchDay";
import InitSeason from "../components/InitSeason";
import RoleList from "../components/RoleList";
import UserList from "../components/UserList";
import FileUploader from "../components/FileUploader";
import SeasonDataService from "../services/season-data.service";

export default {
  name: 'Admin',
  components: {
    FileUploader,
    InitSeason,
    InitMatchDay, RoleList, UserList
  },
  computed: {
    currentUser() {
      return this.$store.state.auth.user;
    }
  },
  data() {
    return {
      content: '',
      checkMaintenance: this.$store.state.sys.isMaintenance
    };
  },
  watch: {
    checkMaintenance: function (newVal, oldVal) {
      console.log("New: " + newVal + " --> Old: " + oldVal);
      if (newVal === false) {
        this.$store.dispatch('sys/switchMaintenanceUser', null);
      }
      SeasonDataService.setMode(newVal)
          .then(result => {
            console.log(result.data);
          })
          .catch(err => {
            console.error(err);
          })
    }
  },
  mounted() {
    UserService.getAdminBoard().then(
        response => {
          this.content = response.data;
          this.$store.dispatch('sys/getCurrentSeasonYear');
        },
        error => {
          if (error.response.status === 401) {
            this.content = "Du bist nicht eingeloggt!";
            this.$store.dispatch('auth/logout');
            this.$router.push('/login');
          } else {
            this.content =
                (error.response && error.response.data) ||
                error.message ||
                error.toString();
          }
        }
    );
  }
};
</script>